import { useState } from "react";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import RespSidebar from "./RespSidebar";
import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import "./SuccessPopup.css";
export default function Contact() {
  const [Drop, setDrop] = useState(false);
  const form = useRef();
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    to_name: "",
    from_name: "",
    message: "",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = {};
    if (!formData.to_name.trim()) {
      validationErrors.to_name = "Full name is required";
    }
    if (!formData.from_name.trim()) {
      validationErrors.from_name = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.from_name)) {
      validationErrors.from_name = "Email is invalid";
    }
    if (!formData.message.trim()) {
      validationErrors.message = "Message is required";
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    emailjs
      .sendForm("service_u8bp2i3", "template_cqv56ei", form.current, {
        publicKey: "wsm855-KEVDHZhl5S",
      })
      .then(
        () => {
          console.log("SUCCESS!");
          setShowSuccessPopup(true);
          setTimeout(() => {
            setShowSuccessPopup(false);
          }, 3000);
        },
        (err) => {
          console.log("FAILED...", err.text);
        }
      );
    setFormData({
      to_name: "",
      from_name: "",
      message: "",
    });
    setErrors({});
  };
  return (
    <div>
      <main>
        {Drop ? (
          <RespSidebar setDropDown={setDrop} />
        ) : (
          <Sidebar setDropDown={setDrop} />
        )}

        <div className="main-content">
          <Navbar link="contact" />

          <article className="contact active" data-page="contact">
            <header>
              <h2 className="h2 article-title typing-text">Contact</h2>
            </header>
            <section className="mapbox" data-mapbox="">
              <figure>
                <iframe
                  title="maps"
                  height="300"
                  loading="lazy"
                  src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d658.0197578469445!2d78.97288033089303!3d21.09973041148355!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2s!5e0!3m2!1sen!2sin!4v1728577809135!5m2!1sen!2sin"
                  width="400"
                />
              </figure>
            </section>
            <section className="contact-form">
              <h3 className="h3 form-title">Contact Form</h3>
              <form action="#" ref={form} className="form" data-form="">
                <div className="input-wrapper">
                  <div>
                    <input
                      className="form-input"
                      data-form-input=""
                      name="to_name"
                      placeholder="Full name"
                      value={formData.to_name}
                      onChange={handleChange}
                      required
                      type="text"
                    />
                    {errors.to_name && (
                      <span className="error">{errors.to_name}</span>
                    )}
                  </div>
                  <div>
                    <input
                      className="form-input"
                      data-form-input=""
                      name="from_name"
                      placeholder="Email address"
                      value={formData.from_name}
                      onChange={handleChange}
                      required
                      type="email"
                    />
                    {errors.from_name && (
                      <span className="error">{errors.from_name}</span>
                    )}
                  </div>
                </div>
                <textarea
                  className="form-input"
                  data-form-input=""
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Your Message"
                  required
                />
                {errors.message && (
                  <span className="error">{errors.message}</span>
                )}
                <button
                  className="form-btn"
                  data-form-btn=""
                  onClick={handleSubmit}
                  type="submit"
                >
                  <ion-icon name="paper-plane" />
                  <span>Send Message</span>
                </button>
              </form>
              {showSuccessPopup && (
                <div className="success-popup">
                  <p>Message sent successfully!</p>
                </div>
              )}
            </section>
          </article>
        </div>
      </main>
    </div>
  );
}
